import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import apiAsyncThunkCreator from '../../../../services/apiAsyncThunkCreator';
import { HttpMethods, SERVICES } from '../../../../services/api';
import { ThunkAPI } from '../../../rootReducer';
import { IArgsFetchCampaigns, ICampaign } from './campaigns.interface';
import { Regions } from '../../../../components/common/domain/accountRegions';

// TODO: Remove this entire file when Features.BillingUserFacing is approved in staging and prod
export const fetchCampaignsForAccount: AsyncThunk<ICampaign[], IArgsFetchCampaigns, ThunkAPI> = createAsyncThunk(
  'accounts/fetchCampaignsForAccount',
  (data: IArgsFetchCampaigns, thunk) => {
    const { accountId, states = [], region } = data;
    let serviceUrl;
    switch (region) {
    case Regions.Australia: {
      serviceUrl = SERVICES.CAMPAIGNS_SERVICE_AU;
      break;
    }
    case Regions.EuropeUnion: {
      serviceUrl = SERVICES.CAMPAIGNS_SERVICE_EUROPE;
      break;
    }
    default: {
      serviceUrl = SERVICES.CAMPAIGNS_SERVICE;
      break;
    }}
    const payload = {
      states
    };
    return apiAsyncThunkCreator<ICampaign[], { states: string[] }>({
      endpoint: `/campaigns/get-campaigns-by-state/${accountId}`,
      microservice: serviceUrl,
      authenticated: true,
      method: HttpMethods.Post
    })(payload, thunk);
  }
);
